<div
    class="z-999 sticky top-0 transition-[background-color,box-shadow] duration-300"
    [ngClass]="{
        'dark text-white-dark': store.semidark && store.menu === 'horizontal',
        'bg-[#f6f6f6] dark:bg-[#0e1726]': isScrolled,
        'bg-transparent': !isScrolled
    }"
>
    <div class="relative flex w-full items-center px-3 py-2.5 sm:px-5">
        <div class="horizontal-logo flex items-center justify-between ltr:mr-2 rtl:ml-2 lg:hidden">
            <a routerLink="/" class="main-logo flex shrink-0 items-center">
                <img class="inline w-8 ltr:-ml-1 rtl:-mr-1" src="/assets/images/logo.png" alt="" />
                <span class="logo-text hidden align-middle text-2xl font-light transition-all duration-300 ltr:ml-1.5 rtl:mr-1.5 dark:text-white-light md:inline">
                    Brickhub
                </span>
            </a>

            <a
                href="javascript:;"
                class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary ltr:ml-2 rtl:mr-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                (click)="storeData.dispatch({type: 'toggleSidebar'})"
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 7L4 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path opacity="0.5" d="M20 12L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M20 17L4 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </a>
        </div>
        <div class="hidden ltr:mr-2 rtl:ml-2 sm:block"></div>
        <div
            class="flex items-center space-x-1.5 ltr:ml-auto rtl:mr-auto rtl:space-x-reverse dark:text-[#d0d2d6] sm:flex-1 ltr:sm:ml-0 sm:rtl:mr-0 lg:space-x-2"
        >
            <div class="sm:ltr:mr-auto sm:rtl:ml-auto">
                <form
                    class="absolute inset-x-0 top-1/2 z-10 mx-4 hidden -translate-y-1/2 sm:relative sm:top-0 sm:mx-0 sm:block sm:translate-y-0"
                    [ngClass]="{ 'block!': search }"
                    (submit.prevent)="search = false"
                >
                    <div class="cp-search-field relative">
                        <span class="cp-search-field__icon" aria-hidden="true">
                            <icon-search class="h-4 w-4"></icon-search>
                        </span>
                        <input
                            type="search"
                            class="form-input cp-search-input !bg-transparent dark:border-gray-700 placeholder:tracking-widest ltr:pr-4 rtl:pl-4 sm:bg-transparent"
                            placeholder="Search..."
                            aria-label="Search"
                        />
                        <button
                            type="button"
                            class="absolute top-1/2 block -translate-y-1/2 hover:opacity-80 ltr:right-2 rtl:left-2 sm:hidden"
                            (click)="search = false"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle opacity="0.5" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
                                <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                        </button>
                    </div>
                </form>
                
                <button
                    type="button"
                    class="search_btn rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 dark:bg-dark/40 dark:hover:bg-dark/60 sm:hidden"
                    (click)="search = !search"
                >
                    <svg
                        class="mx-auto h-4.5 w-4.5 dark:text-[#d0d2d6]"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="11.5" cy="11.5" r="9.5" stroke="currentColor" stroke-width="1.5" opacity="0.5" />
                        <path d="M18.5 18.5L22 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                </button>
            </div>
            <div>
                @if (store.theme === 'light') {
                <a
                    href="javascript:;"
                    class="flex items-center rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    (click)="storeData.dispatch({type: 'toggleTheme', payload:'dark'})"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="1.5" />
                        <path d="M12 2V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M12 20V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M4 12L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M22 12L20 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M19.7778 4.22266L17.5558 6.25424" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M4.22217 4.22266L6.44418 6.25424" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M6.44434 17.5557L4.22211 19.7779" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M19.7778 19.7773L17.5558 17.5551" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                </a>
                }
                @if (store.theme === 'dark') {
                <a
                    href="javascript:;"
                    class="flex items-center rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    (click)="storeData.dispatch({type: 'toggleTheme', payload:'system'})"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M21.0672 11.8568L20.4253 11.469L21.0672 11.8568ZM12.1432 2.93276L11.7553 2.29085V2.29085L12.1432 2.93276ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25C1.25 17.9371 6.06294 22.75 12 22.75V21.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM15.5 14.25C12.3244 14.25 9.75 11.6756 9.75 8.5H8.25C8.25 12.5041 11.4959 15.75 15.5 15.75V14.25ZM20.4253 11.469C19.4172 13.1373 17.5882 14.25 15.5 14.25V15.75C18.1349 15.75 20.4407 14.3439 21.7092 12.2447L20.4253 11.469ZM9.75 8.5C9.75 6.41182 10.8627 4.5828 12.531 3.57467L11.7553 2.29085C9.65609 3.5593 8.25 5.86509 8.25 8.5H9.75ZM12 2.75C11.9115 2.75 11.8077 2.71008 11.7324 2.63168C11.6686 2.56527 11.6538 2.50244 11.6503 2.47703C11.6461 2.44587 11.6482 2.35557 11.7553 2.29085L12.531 3.57467C13.0342 3.27065 13.196 2.71398 13.1368 2.27627C13.0754 1.82126 12.7166 1.25 12 1.25V2.75ZM21.7092 12.2447C21.6444 12.3518 21.5541 12.3539 21.523 12.3497C21.4976 12.3462 21.4347 12.3314 21.3683 12.2676C21.2899 12.1923 21.25 12.0885 21.25 12H22.75C22.75 11.2834 22.1787 10.9246 21.7237 10.8632C21.286 10.804 20.7293 10.9658 20.4253 11.469L21.7092 12.2447Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                }
                @if (store.theme === 'system') {
                <a
                    href="javascript:;"
                    class="flex items-center rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    (click)="storeData.dispatch({type: 'toggleTheme', payload:'light'})"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3 9C3 6.17157 3 4.75736 3.87868 3.87868C4.75736 3 6.17157 3 9 3H15C17.8284 3 19.2426 3 20.1213 3.87868C21 4.75736 21 6.17157 21 9V14C21 15.8856 21 16.8284 20.4142 17.4142C19.8284 18 18.8856 18 17 18H7C5.11438 18 4.17157 18 3.58579 17.4142C3 16.8284 3 15.8856 3 14V9Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                        />
                        <path opacity="0.5" d="M22 21H2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M15 15H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                </a>
                }
            </div>

            <div class="dropdown shrink-0">
                <div hlMenu>
                    <button
                        type="button"
                        hlMenuButton
                        class="block rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22 10C22.0185 10.7271 22 11.0542 22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H13"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                            />
                            <path
                                d="M6 8L8.1589 9.79908C9.99553 11.3296 10.9139 12.0949 12 12.0949C13.0861 12.0949 14.0045 11.3296 15.8411 9.79908"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                            />
                            <circle cx="19" cy="5" r="3" stroke="currentColor" stroke-width="1.5" />
                        </svg>
                    </button>
                    <ul
                        *hlMenuItems
                        animate.enter="bh-toggle-enter"
                        animate.leave="bh-toggle-leave"
                        class="fixed! inset-x-3 top-[3.75rem] z-1000 w-auto max-h-[min(70vh,32rem)] overflow-y-auto overflow-x-hidden py-0! text-xs text-dark dark:text-white-dark sm:absolute! sm:inset-x-auto sm:top-11 sm:w-[375px] sm:max-h-none sm:ltr:-right-2 sm:rtl:-left-2"
                    >
                        <li class="mb-5">
                            <div class="relative overflow-hidden rounded-t-md p-4! text-white sm:p-5!">
                                <div
                                    class="bg-[url('/assets/images/menu-heade.jpg')] absolute inset-0 h-full w-full bg-cover bg-center bg-no-repeat"
                                ></div>
                                <h4 class="relative z-10 text-lg font-semibold">Messages</h4>
                            </div>
                        </li>
                        @for (msg of messages; track msg.id) {
                        <li>
                            <div class="flex items-start gap-2 py-3 px-3 sm:items-center sm:px-5">
                                <div class="shrink-0" [innerHTML]="msg.image"></div>
                                <span class="min-w-0 flex-1 dark:text-gray-500">
                                    <div class="text-sm font-semibold dark:text-white-light/90">{{msg.title}}</div>
                                    <div class="wrap-break-word">{{msg.message}}</div>
                                </span>
                                <span
                                    class="shrink-0 whitespace-nowrap rounded bg-white-dark/20 px-1 font-semibold text-dark/60 dark:text-white-dark"
                                    >{{msg.time}}</span
                                >
                                <button type="button" class="shrink-0 text-neutral-300 hover:text-danger" (click)="$event.stopPropagation()">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle opacity="0.5" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
                                        <path
                                            d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
                                            stroke="currentColor"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </li>
                        }
                        @if (messages.length) {
                        <li class="mt-5 border-t border-white-light text-center dark:border-white/10">
                            <div
                                class="group flex cursor-pointer items-center justify-center py-4 px-5 font-semibold text-primary dark:text-gray-400"
                                *hlMenuItem="let menuItem"
                            >
                                <span class="group-hover:underline ltr:mr-1 rtl:ml-1">VIEW ALL ACTIVITIES</span>

                                <svg
                                    class="h-4 w-4 transition duration-300 group-hover:translate-x-1 ltr:ml-1 rtl:mr-1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M4 12H20M20 12L14 6M20 12L14 18"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </li>
                        }
                        @if (!messages.length) {
                        <li class="mb-5">
                            <div class="grid! min-h-[200px] place-content-center text-lg hover:bg-transparent!">
                                <div class="mx-auto mb-4 rounded-full text-primary ring-4 ring-primary/30">
                                    <svg width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            opacity="0.5"
                                            d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
                                            fill="currentColor"
                                        />
                                        <path
                                            d="M10 4.25C10.4142 4.25 10.75 4.58579 10.75 5V11C10.75 11.4142 10.4142 11.75 10 11.75C9.58579 11.75 9.25 11.4142 9.25 11V5C9.25 4.58579 9.58579 4.25 10 4.25Z"
                                            fill="currentColor"
                                        />
                                        <path
                                            d="M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </div>
                                No data available.
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </div>

            <div class="dropdown shrink-0">
                <div hlMenu>
                    <button
                        type="button"
                        hlMenuButton
                        class="notification-bell relative block rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                        title="Notifications"
                        (click)="onNotificationBellClick()"
                    >
                        <icon-bell class="h-5 w-5"></icon-bell>
                        <span class="sr-only">Notifications</span>

                        @if (unreadCount() > 0) {
                        <span
                            class="notification-bell__badge absolute -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold leading-none text-white ltr:-right-1 rtl:-left-1"
                        >
                            {{ unreadCount() > 99 ? '99+' : unreadCount() }}
                        </span>
                        }
                    </button>
                    <ul
                        *hlMenuItems
                        animate.enter="bh-toggle-enter"
                        animate.leave="bh-toggle-leave"
                        class="notification-center top-11 z-60 py-0! text-dark ltr:-right-2 rtl:-left-2 dark:text-white-dark"
                    >
                        <li class="notification-center__header">
                            <div class="flex items-start justify-between gap-4">
                                <div>
                                    <div class="flex items-center gap-2">
                                        <h4 class="text-lg font-bold text-black dark:text-white-light">
                                            Notifications
                                        </h4>
                                        @if (unreadCount() > 0) {
                                        <span class="notification-new-badge">
                                            {{ unreadCount() }} new
                                        </span>
                                        }
                                    </div>
                                    <p class="mt-0.5 text-xs text-black/50 dark:text-white-dark/60">
                                        Stay updated with recent activity
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    class="notification-mark-all"
                                    [disabled]="unreadCount() === 0"
                                    aria-label="Mark all notifications as read"
                                    (click)="markAllNotificationsRead($event)"
                                >
                                    <icon-checks class="h-4 w-4"></icon-checks>
                                    <span>Mark all read</span>
                                </button>
                            </div>
                        </li>

                        <li
                            class="notification-center__filters"
                            aria-label="Notification filters"
                        >
                            <div class="notification-filter" role="tablist">
                                <button
                                    type="button"
                                    role="tab"
                                    [attr.aria-selected]="notificationFilter() === 'all'"
                                    [class.notification-filter__button--active]="notificationFilter() === 'all'"
                                    class="notification-filter__button"
                                    (click)="setNotificationFilter('all', $event)"
                                >
                                    All
                                </button>
                                <button
                                    type="button"
                                    role="tab"
                                    [attr.aria-selected]="notificationFilter() === 'unread'"
                                    [class.notification-filter__button--active]="notificationFilter() === 'unread'"
                                    class="notification-filter__button"
                                    (click)="setNotificationFilter('unread', $event)"
                                >
                                    Unread
                                    <span class="notification-filter__count">{{ unreadCount() }}</span>
                                </button>
                                <button
                                    type="button"
                                    role="tab"
                                    [attr.aria-selected]="notificationFilter() === 'read'"
                                    [class.notification-filter__button--active]="notificationFilter() === 'read'"
                                    class="notification-filter__button"
                                    (click)="setNotificationFilter('read', $event)"
                                >
                                    Read
                                </button>
                            </div>
                        </li>

                        <li class="p-0!">
                            <div
                                class="notification-center__list"
                                role="tabpanel"
                                (scroll)="onNotificationScroll($event)"
                            >
                                @if (notificationsService.loading() && !hasFilteredNotifications()) {
                                <div
                                    class="notification-skeletons"
                                    aria-label="Loading notifications"
                                >
                                    @for (skeleton of [1, 2, 3, 4, 5]; track skeleton) {
                                    <div class="notification-skeleton">
                                        <span class="notification-skeleton__icon"></span>
                                        <span class="min-w-0 flex-1">
                                            <span
                                                class="notification-skeleton__line notification-skeleton__line--title"
                                            ></span>
                                            <span
                                                class="notification-skeleton__line notification-skeleton__line--body"
                                            ></span>
                                            <span
                                                class="notification-skeleton__line notification-skeleton__line--time"
                                            ></span>
                                        </span>
                                    </div>
                                    }
                                </div>
                                } @else if (notificationsService.error() && !hasFilteredNotifications()) {
                                <div class="notification-empty">
                                    <span class="notification-empty__icon">
                                        <icon-info-triangle class="h-8 w-8"></icon-info-triangle>
                                    </span>
                                    <h5>Something went wrong</h5>
                                    <p>{{ notificationsService.error() }}</p>
                                    <button
                                        type="button"
                                        class="notification-mark-all mt-3"
                                        (click)="retryNotifications($event)"
                                    >
                                        <icon-refresh class="h-4 w-4"></icon-refresh>
                                        <span>Retry</span>
                                    </button>
                                </div>
                                } @else if (hasFilteredNotifications()) {
                                @for (group of groupedNotifications(); track group.label) {
                                <section
                                    class="notification-group"
                                    [attr.aria-labelledby]="'notification-group-' + group.label"
                                >
                                    <h5
                                        class="notification-group__label"
                                        [id]="'notification-group-' + group.label"
                                    >
                                        {{ group.label }}
                                    </h5>
                                    <div class="notification-group__items">
                                        @for (notification of group.notifications; track notification.id) {
                                        <div
                                            class="notification-item"
                                            [class.notification-item--unread]="!notification.isRead"
                                        >
                                            <button
                                                type="button"
                                                class="notification-item__content"
                                                [attr.aria-label]="(notification.isRead ? 'Open read notification: ' : 'Open unread notification: ') + (notification.title || 'New notification')"
                                                (click)="onNotificationSelect(notification)"
                                            >
                                                <span
                                                    class="notification-icon"
                                                    [ngClass]="'notification-icon--' + getNotificationType(notification)"
                                                >
                                                    @switch (getNotificationType(notification)) {
                                                    @case ('payment') {
                                                    <icon-cash-banknotes class="h-5 w-5"></icon-cash-banknotes>
                                                    } @case ('success') {
                                                    <icon-circle-check class="h-5 w-5"></icon-circle-check>
                                                    } @case ('warning') {
                                                    <icon-info-triangle class="h-5 w-5"></icon-info-triangle>
                                                    } @case ('failure') {
                                                    <icon-x-circle class="h-5 w-5"></icon-x-circle>
                                                    } @case ('booking') {
                                                    <icon-home class="h-5 w-5"></icon-home>
                                                    } @case ('document') {
                                                    <icon-file class="h-5 w-5"></icon-file>
                                                    } @case ('reminder') {
                                                    <icon-clock class="h-5 w-5"></icon-clock>
                                                    } @case ('user') {
                                                    <icon-user class="h-5 w-5"></icon-user>
                                                    } @default {
                                                    <icon-bell class="h-5 w-5"></icon-bell>
                                                    } }
                                                </span>
                                                <span class="min-w-0 flex-1 text-left rtl:text-right">
                                                    <span class="notification-item__title">
                                                        {{ notification.title || 'New notification' }}
                                                    </span>
                                                    @if (notification.body) {
                                                    <span class="notification-item__message">
                                                        {{ notification.body }}
                                                    </span>
                                                    } @if (notification.message) {
                                                    <span
                                                        class="notification-item__message"
                                                        [innerHTML]="notification.message"
                                                    ></span>
                                                    } @if (notification.time) {
                                                    <span class="notification-item__time">
                                                        <icon-clock class="h-3.5 w-3.5"></icon-clock>
                                                        {{ notification.time }}
                                                    </span>
                                                    }
                                                </span>
                                            </button>
                                            @if (!notification.isRead) {
                                            <span
                                                class="notification-item__dot"
                                                aria-hidden="true"
                                            ></span>
                                            <button
                                                type="button"
                                                class="notification-item__read-action"
                                                aria-label="Mark notification as read"
                                                title="Mark as read"
                                                (click)="markNotificationRead(notification.id, $event)"
                                            >
                                                <icon-checks class="h-4 w-4"></icon-checks>
                                            </button>
                                            }
                                        </div>
                                        }
                                    </div>
                                </section>
                                } @if (isLoadingMore()) {
                                <div class="notification-loading-more">
                                    <icon-loader class="h-4 w-4 animate-spin"></icon-loader>
                                    Loading more
                                </div>
                                } } @else {
                                <div class="notification-empty">
                                    <span class="notification-empty__icon">
                                        @if (notificationFilter() === 'unread') {
                                        <icon-circle-check class="h-8 w-8"></icon-circle-check>
                                        } @else {
                                        <icon-bell class="h-8 w-8"></icon-bell>
                                        }
                                    </span>
                                    @switch (notificationFilter()) {
                                    @case ('unread') {
                                    <h5>You're all caught up</h5>
                                    <p>No unread notifications.</p>
                                    } @case ('read') {
                                    <h5>No read notifications yet</h5>
                                    <p>Notifications you read will appear here.</p>
                                    } @default {
                                    <h5>No notifications yet</h5>
                                    <p>We'll let you know when something needs your attention.</p>
                                    } }
                                </div>
                                }
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            @if (showWorkspaceSwitcher) {
            <div class="dropdown shrink-0">
                <div hlMenu class="block!">
                    <button
                        type="button"
                        hlMenuButton
                        class="group relative flex items-center gap-2 p-1 bg-white hover:bg-white hover:text-primary rounded-full dark:bg-dark/40 dark:hover:bg-dark/60"
                        [disabled]="workspaceSwitching()"
                        (click)="onWorkspaceMenuToggle()"
                    >
                        <span
                            class="grid h-7 w-7 place-content-center rounded-full bg-primary/10 text-primary dark:bg-primary/20"
                        >
                            <icon-users-group class="h-4 w-4 shrink-0" />
                        </span>
                        <span class="hidden text-xs font-semibold truncate max-w-[100px] sm:inline">{{
                            currentWorkspaceName()
                        }}</span>
                        @if (currentWorkspace(); as active) {
                        <span
                            class="hidden rounded px-1 text-[10px] font-semibold uppercase tracking-wide sm:inline"
                            [ngClass]="isCpDefaultWorkspace(active) ? 'bg-primary/10 text-primary' : 'bg-success-light text-success'"
                        >
                            {{ isCpDefaultWorkspace(active) ? 'CP Default' : 'Builder' }}
                        </span>
                        }
                        <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': activeDropdown.includes('workspace') }">
                            <icon-caret-down />
                        </div>
                    </button>
                    <ul
                        *hlMenuItems
                        animate.enter="bh-toggle-enter"
                        animate.leave="bh-toggle-leave"
                        class="top-11 w-[300px] py-0! text-dark ltr:right-0 rtl:left-0 dark:text-white-dark dark:text-white-light/90 sm:w-[340px]"
                    >
                        <li>
                            <div class="border-b border-white-light px-4 py-3 dark:border-white-light/10">
                                <h4 class="text-base font-semibold">Workspaces</h4>
                                <p class="mt-0.5 text-xs text-black/60 dark:text-dark-light/60">
                                    Switch between your default workspace and connected builders
                                </p>
                            </div>
                        </li>

                        @if (workspacesLoading()) {
                        <li>
                            <div class="grid! min-h-[120px] place-content-center text-sm text-black/60 hover:bg-transparent! dark:text-dark-light/60">
                                Loading workspaces…
                            </div>
                        </li>
                        } @else if (workspacesError()) {
                        <li>
                            <div class="px-4 py-6 text-center text-sm text-danger hover:bg-transparent!">
                                {{ workspacesError() }}
                            </div>
                        </li>
                        } @else if (!workspaces().length) {
                        <li>
                            <div class="px-4 py-6 text-center text-sm text-black/60 hover:bg-transparent! dark:text-dark-light/60">
                                No connected workspaces available.
                            </div>
                        </li>
                        } @else {
                        @for (workspace of workspaces(); track workspace.workspaceId) {
                        <li>
                            <div class="flex items-start gap-3 px-4 py-3">
                                <div
                                    class="grid h-10 w-10 shrink-0 place-content-center rounded-md bg-primary/10 text-sm font-semibold text-primary dark:bg-primary/20"
                                    aria-hidden="true"
                                >
                                    {{ workspaceInitials(workspace) }}
                                </div>
                                <div class="min-w-0 flex-1">
                                    <div class="flex flex-wrap items-center gap-1.5">
                                        <h4 class="truncate text-sm font-semibold dark:text-white-light/90">
                                            {{ workspace.workspaceName }}
                                        </h4>
                                        @if (isCurrentWorkspace(workspace.workspaceId)) {
                                        <span
                                            class="rounded bg-success-light px-1 text-[10px] font-semibold uppercase tracking-wide text-success"
                                        >
                                            Current
                                        </span>
                                        }
                                        @if (isDefaultWorkspace(workspace.workspaceId)) {
                                        <span
                                            class="rounded bg-primary/10 px-1 text-[10px] font-semibold uppercase tracking-wide text-primary"
                                        >
                                            Default
                                        </span>
                                        }
                                    </div>
                                    <p class="mt-0.5 truncate text-xs text-black/60 dark:text-dark-light/60">
                                        {{ workspace.partnerLegalName }}
                                    </p>
                                    <p class="mt-1 text-[11px] font-medium text-success">
                                        {{ workspaceTypeLabel(workspace) }} · {{ workspaceStatusLabel(workspace) }}
                                    </p>
                                </div>
                                @if (hasMultipleWorkspaces && !isCurrentWorkspace(workspace.workspaceId)) {
                                <button
                                    type="button"
                                    class="btn btn-dark btn-sm shrink-0 rounded-full px-3 py-1 text-xs shadow-none"
                                    [disabled]="workspaceSwitching()"
                                    (click)="switchToWorkspace($event, workspace)"
                                >
                                    Switch Workspace
                                </button>
                                }
                            </div>
                        </li>
                        }
                        @if (!hasMultipleWorkspaces) {
                        <li>
                            <div
                                class="border-t border-white-light px-4 py-3 text-center text-xs text-black/60 hover:bg-transparent! dark:border-white-light/10 dark:text-dark-light/60"
                            >
                                Only one workspace is available. Connect a builder to add another.
                            </div>
                        </li>
                        }
                        }

                        <li class="border-t border-white-light dark:border-white-light/10">
                            <a
                                href="/my-profile"
                                routerLink="/my-profile"
                                *hlMenuItem="let menuItem"
                                class="dark:hover:text-white"
                                (click)="goToWorkspaceSettings($event)"
                            >
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2 19.5H22"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        d="M4 19.5V9.5C4 8.67157 4.67157 8 5.5 8H9.5C10.3284 8 11 8.67157 11 9.5V19.5"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M11 19.5V5.5C11 4.67157 11.6716 4 12.5 4H18.5C19.3284 4 20 4.67157 20 5.5V19.5"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                </svg>
                                Manage workspaces
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            }

            <div class="dropdown shrink-0">
                <div hlMenu class="block!">
                    <button type="button" hlMenuButton class="group relative flex items-center gap-2 p-1 bg-white hover:bg-white hover:text-primary rounded-full dark:bg-dark/40 dark:hover:bg-dark/60" (click)="toggleDropdown('profile')">
                        <img class="h-7 w-7 rounded-full object-cover saturate-50 group-hover:saturate-100" [src]="headerAvatarUrl()" alt="" />
                        <span class="hidden text-xs font-semibold truncate max-w-[100px] sm:inline">{{ userDisplayName() }}</span>
                        
                        <div class="hidden sm:block" [ngClass]="{ 'rtl:rotate-90 -rotate-90': activeDropdown.includes('profile')}">
                            <icon-caret-down />
                        </div>
                    </button>
                    <ul
                        *hlMenuItems
                        animate.enter="bh-toggle-enter"
                        animate.leave="bh-toggle-leave"
                        class="top-11 w-[230px] py-0! text-dark ltr:right-0 rtl:left-0 dark:text-white-dark dark:text-white-light/90"
                    >
                        <li>
                            <div class="flex items-center px-4 py-4">
                                <div class="flex-none">
                                    <img class="h-10 w-10 rounded-md object-cover" [src]="headerAvatarUrl()" alt="" />
                                </div>
                                <div class="truncate ltr:pl-4 rtl:pr-4">
                                    <h4 class="text-base">
                                        {{ userDisplayName() }}<span class="rounded bg-success-light px-1 text-xs text-success ltr:ml-2 rtl:ml-2">Pro</span>
                                    </h4>
                                    <app-copyable-text [value]="userEmail()" label="Email"
                                        textClass="text-black/60 dark:text-dark-light/60" />
                                </div>
                            </div>
                        </li>
                        <li>
                            <a
                                href="/my-profile"
                                routerLink="/my-profile"
                                *hlMenuItem="let menuItem"
                                class="dark:hover:text-white"
                                (click)="goToMyProfile($event)">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle cx="12" cy="6" r="4" stroke="currentColor" stroke-width="1.5" />
                                    <path
                                        opacity="0.5"
                                        d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                </svg>

                               My Profile
                            </a>
                        </li>
                        <li>
                            <a routerLink="/mailbox" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <svg
                                    class="h-4 w-4 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M17.5 17.5L22 22"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                </svg>

                                Explore More Properties
                            </a>
                        </li>
                        <li class="border-t border-white-light dark:border-white-light/10">
                            <a routerLink="/auth/login" (click)="onSignOut($event)" *hlMenuItem="let menuItem" class="py-3! text-danger">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 rotate-90 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.5"
                                        d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                Log Out
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- horizontal menu -->
    <ul
        class="horizontal-menu hidden border-t border-[#ebedf2] bg-white py-1.5 px-4 font-semibold text-black rtl:space-x-reverse dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white-dark lg:space-x-1.5 xl:space-x-2"
    >
        <li class="menu nav-item relative">
            <a routerLink="/dashboard" class="nav-link">
                <div class="flex items-center">
                   <icon-menu-dashboard class="shrink-0" />
                    <span class="px-2">{{ 'Dashboard' | translate }}</span>
                </div>
            </a>
        </li>
        <li class="menu nav-item relative">
            <a routerLink="/leads" class="nav-link">
                <div class="flex items-center">
                   <icon-users class="shrink-0" />
                    <span class="px-2">{{ 'Leads' | translate }}</span>
                </div>
            </a>
        </li>
        
    </ul>
</div>
